import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  parrotS: {
    width: 250,
    height: 'auto',
  },
}));

export default useStyles;
